import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import { api } from "../api";
import { fmtDate } from "../lib/labels";

export default function NotificationBell() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);

  const load = () => api.get("/bildirimler").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  const openPanel = async () => {
    setOpen(!open);
    if (!open && data?.unread > 0) {
      await api.post("/bildirimler/okundu").catch(() => {});
      load();
    }
  };

  return (
    <div className="relative">
      <button data-testid="notification-bell" onClick={openPanel}
        className="relative p-2 rounded-lg border border-white/10 nav-ink hover:border-orange-400/40 transition-colors">
        <Bell className="w-4.5 h-4.5 w-[18px] h-[18px]" />
        {data?.unread > 0 && (
          <span data-testid="notification-badge"
            className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 rounded-full bg-orange-500 text-slate-950 text-[10px] font-bold flex items-center justify-center">
            {data.unread}
          </span>
        )}
      </button>
      {open && (
        <div data-testid="notification-panel"
          className="absolute right-0 mt-2 w-80 max-h-96 overflow-y-auto rounded-xl border border-white/10 bg-slate-900 shadow-2xl z-[70]">
          <div className="px-4 py-3 border-b border-white/10 flex items-center justify-between">
            <span className="text-sm font-semibold text-slate-100">Bildirimler</span>
            <button onClick={() => setOpen(false)} className="text-xs text-slate-500 hover:text-slate-300">Kapat</button>
          </div>
          {!data || data.items.length === 0 ? (
            <p className="px-4 py-6 text-sm text-slate-500 text-center">Bildirim yok.</p>
          ) : (
            data.items.map((n) => (
              <Link key={n.id} to={n.link || "#"} onClick={() => setOpen(false)}
                data-testid={`notification-${n.id}`}
                className={`block px-4 py-3 border-b border-white/5 hover:bg-slate-800/50 transition-colors ${!n.read ? "bg-cyan-400/5" : ""}`}>
                <p className="text-sm font-semibold text-slate-100">{n.title}</p>
                <p className="text-xs text-slate-400 mt-0.5">{n.body}</p>
                <p className="text-[10px] text-slate-600 mt-1">{fmtDate(n.created_at)}</p>
              </Link>
            ))
          )}
        </div>
      )}
    </div>
  );
}
